<template>
  <header
    class="text-heading max-w-3xl mx-auto flex flex-col md:flex-wrap py-16 sm:py-24 md:py-32 lg:py-40"
  >
    <h1 class="text-lg md:text-2xl">{{ heading }}</h1>
    <h2 v-if="subheading" class="text-lg md:text-2xl mt-6">{{ subheading }}</h2>
    <slot></slot>
  </header>
</template>

<script>
/**
 * @name App Hero
 * @description Page hero. Can be used as a custom wrapper or by just feeding it props
 * @vue-prop {string} heading - required.
 * @vue-prop {string} subheading - NOT required.
 * @example <hero :heading="heading" :subheading="subheading" />
 */
export default {
  props: {
    heading: {
      type: String,
      required: true
    },
    subheading: String
  }
};
</script>
